var _path, _path2, _path3, _path4, _circle;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4C4 2.89543 4.89543 2 6 2H15L20 7V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4Z",
    fill: "#801EF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2L20 7H15V2Z",
    fill: "#CCA5FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12L15 18H7L11 12Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14L17 18H11L14 14Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 10.5,
    r: 1.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image-icon.8ff0d2b49dced97095792260c5bdfc32.svg";
export { ForwardRef as ReactComponent };